import React, { useEffect } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';

import { fetchWidgetChannel } from 'flow/actions/channels-actions';
import ChannelStatistics from 'flow/components/pbx/ChannelStatistics';
import Loading from 'flow/components/ui-components/Loading';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import PbxLiveChatMessages from 'flow/pages/pbx/live-chats/PbxLiveChatMessages';
import PbxLiveChat from 'flow/route-components/PbxLiveChat';
import PbxLiveChatCalendar from 'flow/route-components/PbxLiveChatCalendar';
import PbxLiveChatGreeting from 'flow/route-components/PbxLiveChatGreeting';
import PbxLiveChatMember from 'flow/route-components/PbxLiveChatMember';
import PbxLiveChatMessageSettings from 'flow/route-components/PbxLiveChatMessageSettings';
import PbxLiveChatRemoveMember from 'flow/route-components/PbxLiveChatRemoveMember';
import PbxLiveChatSettings from 'flow/route-components/PbxLiveChatSettings';
import PbxProfiles from 'flow/route-components/PbxProfiles';
import { ChannelKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';

const PbxLiveChatRoutes = () => {
    const dispatch = useAppDispatch();
    const { entityKey: channelKey } = useParams<{ entityKey: ChannelKey }>();

    const channel = useAppSelector((state) =>
        state.channels.getIn(['channels', channelKey]),
    );

    useEffect(() => {
        dispatch(fetchWidgetChannel(channelKey, 'all'));
    }, [dispatch, channelKey]);

    if (!channel?.has('key') || !channel.get('channelMemberDTOs')) {
        return <Loading />;
    }

    return (
        <Switch>
            <Route
                path={routes['pbx.channels.entityKey.profiles.calendar']}
                component={PbxLiveChatCalendar}
            />
            <Route
                path={routes['pbx.channels.entityKey.profiles']}
                component={PbxProfiles}
            />
            <Route
                path={routes['pbx.channels.channelKey.members.remove']}
                component={PbxLiveChatRemoveMember}
            />
            <Route
                path={routes['pbx.channels.channelKey.members']}
                component={PbxLiveChatMember}
            />
            <Route
                path={routes['pbx.channels.entityKey.statistics']}
                component={ChannelStatistics}
            />
            <Route
                path={routes['pbx.channels.entityKey.settings.statistics']}
                component={ChannelStatistics}
            />
            <Route
                path={routes['pbx.channels.channelKey.settings.greeting']}
                component={PbxLiveChatGreeting}
            />
            <Route
                path={routes['pbx.channels.channelKey.settings']}
                component={PbxLiveChatSettings}
            />

            <Route
                path={routes['pbx.channels.channelKey.chatSessionKey.settings']}
                component={PbxLiveChatMessageSettings}
            />

            <Route
                path={routes['pbx.channels.channelKey.chatSessionKey']}
                component={PbxLiveChatMessages}
            />

            <Route
                path={routes['pbx.channels.entityKey']}
                component={PbxLiveChat}
            />
        </Switch>
    );
};

export default PbxLiveChatRoutes;
